import { formatCATDate, formatCATDateTime } from '../../utils/timezone';

export const CLAIM_COOLDOWN_DAYS = 14;

// Server timestamps are UTC; a naive ISO string (no Z / offset) must not be read as browser-local time.
const parseServerTime = (value) => {
  if (value instanceof Date) return value;
  const s = String(value);
  return new Date(/[zZ]$|[+-]\d{2}:\d{2}$/.test(s) ? s : `${s}Z`);
};

export const getClaimCooldownInfo = (lastClaimDate, now = new Date()) => {
  if (!lastClaimDate) {
    return { canCreateClaim: true, daysRemaining: 0, hoursRemaining: 0, minutesRemaining: 0, nextTreatmentDate: null, endsWithin24h: false };
  }

  const lastClaim = parseServerTime(lastClaimDate);
  const cooldownEnd = new Date(lastClaim.getTime() + (CLAIM_COOLDOWN_DAYS * 24 * 60 * 60 * 1000));
  const timeDiff = cooldownEnd - now;

  // Cooldown holds until the very last minute
  if (timeDiff <= 0) {
    return { canCreateClaim: true, daysRemaining: 0, hoursRemaining: 0, minutesRemaining: 0, nextTreatmentDate: null, endsWithin24h: false };
  }

  const daysRemaining = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
  const hoursRemaining = Math.floor((timeDiff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutesRemaining = Math.floor((timeDiff % (60 * 60 * 1000)) / (60 * 1000));

  return {
    canCreateClaim: false,
    daysRemaining,
    hoursRemaining,
    minutesRemaining,
    endsWithin24h: daysRemaining === 0,
    cooldownEnd: cooldownEnd.toISOString(),
    nextTreatmentDate: formatCATDate(cooldownEnd),
    nextTreatmentTime: formatCATDateTime(cooldownEnd),
    remainingLabel: daysRemaining > 0 ? `${daysRemaining}d ${hoursRemaining}h left` : `${hoursRemaining}h ${minutesRemaining}m left`,
  };
};
